import { useParams } from '@tanstack/react-router';

import { useChats } from './useChats';
import { useChatPanelStore } from '~/features/whatsapp/stores/chatPanelStore';
import { resolveChatContextLoanRequestId } from '~/features/whatsapp/utils/resolveChatContextLoanRequestId';

export const useChatContextLoanRequestId = (chatId: string | null): string | undefined => {
    const { data: chats } = useChats();
    const leadDetailsScopeLoanRequestId = useChatPanelStore.use.leadDetailsScopeLoanRequestId();
    const { leadId: routeLeadId } = useParams({ strict: false });
    const chat = chats?.find((entry) => entry.id === chatId);

    return resolveChatContextLoanRequestId({
        leadDetailsScopeLoanRequestId,
        routeLeadId,
        visibleLoanRequestIds: chat?.visibleLoanRequestIds,
    });
};
